import { render, staticRenderFns } from "./ExternalTaskDetail.vue?vue&type=template&id=2939ac23&"
import script from "./ExternalTaskDetail.vue?vue&type=script&lang=js&"
export * from "./ExternalTaskDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports